import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";
import { IntlCreateOrderPayload, IntlCreateOrderResult } from "../@types/intlFlightAggregator";

/**
 * Books a revalidated offer. The backend re-revalidates and re-quotes FX
 * itself right before booking — this does not yet debit the customer (card/
 * wallet/BNPL wiring is a separate, later step); it books and pays the
 * supplier from Visaro's own balance and persists the booking record.
 */
function useCreateInternationalOrder(
  options?: MutationOptions<APIResponse<IntlCreateOrderResult>, APIError, IntlCreateOrderPayload>
) {
  const {
    isLoading: creatingOrder,
    isError: isCreateOrderError,
    error: createOrderError,
    mutate: createOrder,
    data: createOrderResult,
  } = useMutation<APIResponse<IntlCreateOrderResult>, APIError, IntlCreateOrderPayload>(
    (payload: IntlCreateOrderPayload) => {
      return post(API_URL + "/aviation/international/v2/orders", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    options
  );

  return {
    createOrder,
    createOrderResult,
    createOrderError,
    isCreateOrderError,
    creatingOrder,
  };
}

export default useCreateInternationalOrder;
